<template>
  <el-popover width="400" ref="popperWrapper" popper-class="long-msg-popper" trigger="click">
    <div v-ps class="message">
      <span v-html="value"></span>
    </div>
    <div slot="reference">
      <el-button v-if="value" type="text">查看消息</el-button>
    </div>
  </el-popover>
</template>
<script>
export default {
  name: "long-msg-popper",
  props: {
    value: String
  }
}
</script>

<style lang="scss">
.long-msg-popper {
  .message {
    height: 120px;
  }
}
</style>
